import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Crown } from "lucide-react";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function PaymentSuccess() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) {
      setState("error");
      return;
    }
    let cancelled = false;
    const poll = async (n) => {
      if (cancelled) return;
      if (n > 12) {
        setState("pending");
        return;
      }
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          await refresh();
          setState("paid");
          return;
        }
        if (["failed", "expired"].includes(data.payment_status)) {
          setState("error");
          return;
        }
      } catch {}
      setTries(n + 1);
      setTimeout(() => poll(n + 1), 2000);
    };
    poll(0);
    return () => { cancelled = true; };
  }, [refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] p-4">
      <div className="bg-white rounded-3xl border border-slate-200 shadow-lg p-10 max-w-md w-full text-center">
        {state === "checking" && (
          <>
            <Loader2 className="w-12 h-12 animate-spin text-[#0052CC] mx-auto" />
            <p className="mt-4 font-bold text-slate-700">Validation du paiement...</p>
            <p className="text-xs text-slate-400 mt-1">Tentative {tries + 1}</p>
          </>
        )}
        {state === "paid" && (
          <>
            <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto"><CheckCircle2 className="w-9 h-9 text-emerald-600" /></div>
            <h2 className="text-2xl font-black mt-4 text-slate-900 flex items-center justify-center gap-2"><Crown className="text-[#EAB308]" /> Premium activé !</h2>
            <p className="text-slate-500 mt-2">Générations illimitées débloquées sur les 4 loteries.</p>
            <Button onClick={() => navigate("/")} className="mt-6 rounded-full font-bold text-white bg-[#0052CC] hover:bg-[#003B80]" data-testid="payment-back-btn">Retour à l'application</Button>
          </>
        )}
        {state === "pending" && (
          <>
            <Loader2 className="w-12 h-12 animate-spin text-amber-500 mx-auto" />
            <p className="mt-4 font-bold text-slate-700">Paiement en cours de traitement</p>
            <Button onClick={() => navigate("/")} variant="outline" className="mt-6 rounded-full font-bold">Retour</Button>
          </>
        )}
        {state === "error" && (
          <>
            <div className="w-16 h-16 rounded-full bg-rose-100 flex items-center justify-center mx-auto"><XCircle className="w-9 h-9 text-rose-600" /></div>
            <h2 className="text-xl font-black mt-4 text-slate-900">Paiement non confirmé</h2>
            <Button onClick={() => navigate("/")} className="mt-6 rounded-full font-bold text-white bg-[#0052CC]">Retour</Button>
          </>
        )}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] p-4">
      <div className="bg-white rounded-3xl border border-slate-200 shadow-lg p-10 max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mx-auto"><XCircle className="w-9 h-9 text-slate-500" /></div>
        <h2 className="text-xl font-black mt-4 text-slate-900">Paiement annulé</h2>
        <p className="text-slate-500 mt-2">Aucun montant n'a été débité.</p>
        <Button onClick={() => navigate("/")} className="mt-6 rounded-full font-bold text-white bg-[#0052CC] hover:bg-[#003B80]">Retour à l'application</Button>
      </div>
    </div>
  );
}
